<template>
    <div class="card">
        <div class="card">
            <TabMenu :model="items"/>
            <router-view/>
        </div>
    </div>
</template>

<script>

export default {
    name: "ScheduleRouter",
    components: {},
    data() {
        return {
            items: [
                {
                    label: 'כיתה',
                    icon: 'pi pi-th-large',
                    to: '/schedule',
                    admin: false
                },
                {
                    label: 'מורה',
                    icon: 'pi pi-user',
                    to: '/schedule/teacher',
                    admin: false
                },
            ]
        }
    },
}
</script>

<style scoped>
>>> .p-menuitem-link span {
    margin-left: 7px
}
</style>